// 決済失敗ページ

<template lang="pug">
.outro-page-failed

  .inner

    ps-medium-heading.heading お支払いに失敗しました。

    article.main
      p(v-if='errorCode === "PAYJP_CARD_INVALID"')
        | クレジットカードの情報に誤りがある可能性があります。
        | お手数ですが「戻る」ボタンを押して、再度お手続きをお願いいたします。

      p(v-else)
        | お支払いの処理中にエラーが発生しました。
        | 大変申し訳ございませんが、「戻る」ボタンを押して、再度お手続きをお願いいたします。
        br
        | エラーが続く場合は、お手数ですが弊社までご連絡くださいますようお願い申し上げます。
        br
        br
        | TEL: 0561-55-4051 (平日10:00-17:00)

      .buttons
        ps-button(
          color='green',
          @click='goBackRegister'
        ) 戻る
</template>

<script>
export default {
  name: 'OutroPageFailed',

  computed: {
    errorCode() {
      return this.$route.query.errorCode
    },
  },

  methods: {
    goBackRegister() {
      this.$router.push({
        name: 'OutroPageRegister',
        params: { saleId: this.$route.params.saleId },
      })
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../../sass/variables.sass'
@import '../../../../sass/mixins.sass'

.outro-page-failed

  .inner
    margin-top: 2rem
    background-color: $white
    padding: 1.5rem 1rem
    border-radius: $radius-small
    box-shadow: 0 1px 6px 2px rgba(0, 0, 0, .25)
    +mobile
      padding: 1rem 0.5rem
      box-shadow: 0 1px 1px 1px rgba(0, 0, 0, .3)

    // 通常よりフォントを大きく目立つように
    > .heading
      font-size: $size-largest

    > article
      margin-bottom: 2rem

      &.main
        > *
          margin-bottom: 1rem

        > p
          line-height: 1.4

      > .buttons
        margin-top: 1.5rem
        text-align: center
</style>
